module.exports = __webpack_public_path__ + "static/media/PositiveSelfTalkENG.019ace79.vtt";